module.exports = __webpack_public_path__ + "img/empty-transaction.4ea6ab3c.svg";